function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import 'react-dates/initialize';
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import cx from 'classnames';
import _omit from 'lodash/omit';
import Moment from 'moment';
import { AdaptiveListener, ClickListener } from 'xps-react-utils';
import { DateRangePickerPhrases, SingleDatePickerPhrases } from 'react-dates/lib/defaultPhrases';
import SingleDatePickerWrapper from './SingleDatePickerWrapper';
import SingleDatePickerMobile from './SingleDatePickerMobile';
import DateRangePickerWrapper from './DateRangePickerWrapper';
import DateRangePickerMobile from './DateRangePickerMobile';
import DateRangePicker from './DateRangePicker';
import SingleDatePicker from './SingleDatePicker';
import Label from '../Label';
import InfoPanel from './InfoPanel';
import { getValidElementProps } from '../utils/htmlValidProps';
import { compareMoment, getInitialSelectedFilter, getInitialVisibleMonth as _getInitialVisibleMonth } from './utils';

require('react-dates/lib/css/_datepicker.css');

require('xps-style/core/datepicker.css');

var DatePicker = /*#__PURE__*/function (_Component) {
  _inherits(DatePicker, _Component);

  var _super = _createSuper(DatePicker);

  function DatePicker(props) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (date) {
      var onDateChange = _this.props.onDateChange;
      var setFromFilter = _this.state.setFromFilter;

      if (date !== _this.internalDate) {
        _this.setState({
          date: date,
          selectedFilterButtonName: ''
        });

        _this.internalDate = date;
      }

      if (!setFromFilter) {
        _this.internalSelectedFilterButtonName = '';
      }

      onDateChange(date);
    });

    _defineProperty(_assertThisInitialized(_this), "onDatesChange", function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;
      var onDatesChange = _this.props.onDatesChange;
      var setFromFilter = _this.state.setFromFilter;

      if (startDate !== _this.internalStartDate) {
        _this.setState({
          startDate: startDate,
          selectedFilterButtonName: ''
        });

        _this.internalStartDate = startDate;
      }

      if (endDate !== _this.internalEndDate) {
        _this.setState({
          endDate: endDate,
          selectedFilterButtonName: ''
        });

        _this.internalEndDate = endDate;
      }

      if (!setFromFilter) {
        _this.internalSelectedFilterButtonName = '';
      }

      onDatesChange({
        startDate: startDate,
        endDate: endDate
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFocusChange", function (focus) {
      var onFocusChange = _this.props.onFocusChange;
      var forceFocusEndDate = _this.internalStartDate !== null && _this.internalEndDate === null;
      var forceFocusStartDate = _this.internalStartDate === null && _this.internalEndDate !== null;

      _this.setState({
        focusedInput: (forceFocusEndDate ? 'endDate' : focus) || (forceFocusStartDate ? 'startDate' : focus),
        focused: focus !== null ? focus.focused : null
      });

      onFocusChange(focus);
    });

    _defineProperty(_assertThisInitialized(_this), "onFilter", function (data) {
      var _this$props = _this.props,
          keepOpenOnDateSelect = _this$props.keepOpenOnDateSelect,
          onFilter = _this$props.onFilter;
      var _this$state = _this.state,
          startDate = _this$state.startDate,
          date = _this$state.date;

      var changeVisibleMonth = _this.checkVisibleMonth(startDate, data.startDate);

      var changeVisibleMonthSingle = _this.checkVisibleMonth(date, data.date);

      _this.setState(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, data), keepOpenOnDateSelect && changeVisibleMonth && {
        elKey: data.startDate,
        initialVisibleMonth: data.startDate
      }), keepOpenOnDateSelect && changeVisibleMonthSingle && {
        elKey: data.date,
        initialVisibleMonth: data.date
      }), !keepOpenOnDateSelect && {
        focusedInput: null,
        focused: null
      }), {}, {
        setFromFilter: true
      }));

      onFilter(data);
    });

    _defineProperty(_assertThisInitialized(_this), "getInitialVisibleMonth", function () {
      _this.setState({
        initialVisibleMonth: function initialVisibleMonth() {
          return _getInitialVisibleMonth(_this.state, _this.props);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "checkVisibleMonth", function (prevStartDate, newStartDate) {
      var currVisibleMonth = Moment(prevStartDate).format('YYYY-MM');
      var nextVisibleMonth = Moment(newStartDate).format('YYYY-MM');

      if (currVisibleMonth !== nextVisibleMonth) {
        return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function () {
      var onCancel = _this.props.onCancel;

      _this.setState({
        focusedInput: null,
        focused: null,
        startDate: _this.internalStartDate,
        endDate: _this.internalEndDate,
        date: _this.internalDate,
        selectedFilterButtonName: _this.internalSelectedFilterButtonName
      }, _this.getInitialVisibleMonth);

      onCancel();
    });

    _defineProperty(_assertThisInitialized(_this), "onAccept", function () {
      var onAccept = _this.props.onAccept;

      _this.setInternalDates();

      _this.setState({
        focusedInput: null,
        focused: null
      });

      onAccept();
    });

    _defineProperty(_assertThisInitialized(_this), "onMobileSize", function () {
      var orientation = window.innerWidth < 568 ? 'mobile' : 'tablet';

      _this.updateSize(orientation);
    });

    _defineProperty(_assertThisInitialized(_this), "onTabletSize", function () {
      return _this.updateSize('tablet');
    });

    _defineProperty(_assertThisInitialized(_this), "onDesktopSize", function () {
      return _this.updateSize('desktop');
    });

    _defineProperty(_assertThisInitialized(_this), "calcDaySize", function () {
      return parseInt((window.innerWidth - 32) / 7);
    });

    _defineProperty(_assertThisInitialized(_this), "setInternalDates", function () {
      var _this$state2 = _this.state,
          startDate = _this$state2.startDate,
          endDate = _this$state2.endDate,
          date = _this$state2.date,
          selectedFilterButtonName = _this$state2.selectedFilterButtonName,
          setFromFilter = _this$state2.setFromFilter;
      _this.internalStartDate = startDate;
      _this.internalEndDate = endDate;
      _this.internalDate = date;

      if (setFromFilter) {
        _this.internalSelectedFilterButtonName = selectedFilterButtonName;
      } else {
        _this.internalSelectedFilterButtonName = '';
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onOutsideClickListener", function (e) {
      if (e && e.composedPath) {
        var pathIncludesExceptions = e.composedPath().filter(function (ele) {
          if (ele.className) {
            return ele.className.includes('datepicker__infoPanel');
          } else {
            return false;
          }
        });

        if (pathIncludesExceptions.length > 0) {
          return;
        }
      }

      _this.setInternalDates();
    });

    _defineProperty(_assertThisInitialized(_this), "AdaptiveDatePicker", function (ownProps) {
      var _this$props2 = _this.props,
          filters = _this$props2.filters,
          type = _this$props2.type,
          onAccept = _this$props2.onAccept,
          onOutsideClick = _this$props2.onOutsideClick,
          placeholder = _this$props2.placeholder,
          startDatePlaceholderText = _this$props2.startDatePlaceholderText,
          endDatePlaceholderText = _this$props2.endDatePlaceholderText,
          displayFormat = _this$props2.displayFormat,
          disableTyping = _this$props2.disableTyping,
          applyButtonText = _this$props2.applyButtonText,
          onFilter = _this$props2.onFilter;
      var _this$state3 = _this.state,
          screenSize = _this$state3.screenSize,
          isTouchDevice = _this$state3.isTouchDevice;

      if (type === 'range' && screenSize === 'mobile') {
        return /*#__PURE__*/React.createElement(DateRangePickerMobile, _extends({}, ownProps, {
          onCancel: _this.onCancel,
          filters: filters,
          onFilter: onFilter,
          daySize: _this.calcDaySize(),
          onAccept: onAccept,
          startDatePlaceholderText: startDatePlaceholderText,
          endDatePlaceholderText: endDatePlaceholderText,
          readOnly: disableTyping,
          applyButtonText: applyButtonText,
          displayFormat: displayFormat
        }));
      } else if (type === 'range' && screenSize === 'tablet') {
        return /*#__PURE__*/React.createElement(DateRangePickerWrapper, _extends({}, ownProps, {
          readOnly: isTouchDevice || disableTyping,
          startDatePlaceholderText: startDatePlaceholderText,
          endDatePlaceholderText: endDatePlaceholderText
        }));
      } else if (type === 'range') {
        return /*#__PURE__*/React.createElement(ClickListener, {
          onClickOutside: onOutsideClick || _this.onOutsideClickListener
        }, /*#__PURE__*/React.createElement(DateRangePickerWrapper, _extends({}, ownProps, {
          readOnly: isTouchDevice || disableTyping,
          startDatePlaceholderText: startDatePlaceholderText,
          endDatePlaceholderText: endDatePlaceholderText
        })));
      } else if (screenSize === 'mobile') {
        return /*#__PURE__*/React.createElement(SingleDatePickerMobile, _extends({}, ownProps, {
          onCancel: _this.onCancel,
          filters: filters,
          onFilter: onFilter,
          daySize: _this.calcDaySize(),
          onAccept: onAccept,
          placeholder: placeholder,
          displayFormat: displayFormat,
          readOnly: disableTyping,
          applyButtonText: applyButtonText
        }));
      } else if (screenSize === 'tablet') {
        return /*#__PURE__*/React.createElement(SingleDatePickerWrapper, _extends({}, ownProps, {
          readOnly: isTouchDevice || disableTyping,
          placeholder: placeholder
        }));
      } else {
        return /*#__PURE__*/React.createElement(ClickListener, {
          onClickOutside: onOutsideClick || _this.onOutsideClickListener
        }, /*#__PURE__*/React.createElement(SingleDatePickerWrapper, _extends({}, ownProps, {
          readOnly: isTouchDevice || disableTyping,
          placeholder: placeholder
        })));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateSize", function (size) {
      return _this.setState({
        screenSize: size
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderCalendarInfo", function () {
      var _this$props3 = _this.props,
          filters = _this$props3.filters,
          infoPanelContent = _this$props3.infoPanelContent,
          applyButtonText = _this$props3.applyButtonText;
      var selectedFilterButtonName = _this.state.selectedFilterButtonName;

      if (infoPanelContent && !filters.length) {
        return infoPanelContent();
      }

      return /*#__PURE__*/React.createElement(InfoPanel, {
        filters: filters,
        onClick: _this.onFilter,
        onCancel: _this.onCancel,
        onAccept: _this.onAccept,
        applyButtonText: applyButtonText,
        selectedFilterButtonName: selectedFilterButtonName
      });
    });

    var _this$props4 = _this.props,
        _date = _this$props4.date,
        _endDate = _this$props4.endDate,
        _filters = _this$props4.filters,
        focused = _this$props4.focused,
        focusedInput = _this$props4.focusedInput,
        _startDate = _this$props4.startDate;
    var preselected = getInitialSelectedFilter(_filters);
    _this.state = {
      date: _date,
      endDate: preselected ? preselected.endDate : _endDate,
      selectedFilterButtonName: preselected ? "filterBtn-".concat(preselected.idx + 1) : '',
      focusedInput: focusedInput,
      focused: focused,
      startDate: preselected ? preselected.startDate : _startDate,
      elKey: preselected ? preselected.startDate : _startDate,
      setFromFilter: preselected ? true : false
    };
    _this.internalStartDate = _this.state.startDate;
    _this.internalEndDate = _this.state.endDate;
    _this.internalDate = _this.state.date;
    _this.internalSelectedFilterButtonName = _this.state.selectedFilterButtonName;
    return _this;
  }

  _createClass(DatePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Prevents Keyboard from popping up on touch devices
      window.addEventListener('touchstart', function () {
        _this2.setState({
          isTouchDevice: true
        });
      });
      this.getInitialVisibleMonth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var diffs = compareMoment(prevProps, this.props);

      if (diffs) {
        /* eslint-disable react/no-did-update-set-state */
        this.setState(diffs);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props5 = this.props,
          className = _this$props5.className,
          filters = _this$props5.filters,
          infoPanelContent = _this$props5.infoPanelContent,
          numberOfMonths = _this$props5.numberOfMonths,
          size = _this$props5.size,
          error = _this$props5.error,
          description = _this$props5.description,
          warning = _this$props5.warning,
          label = _this$props5.label,
          id = _this$props5.id,
          required = _this$props5.required,
          type = _this$props5.type,
          phrases = _this$props5.phrases,
          nextVersion = _this$props5.nextVersion,
          displayFormat = _this$props5.displayFormat;
      var _this$state4 = this.state,
          elKey = _this$state4.elKey,
          initialVisibleMonth = _this$state4.initialVisibleMonth,
          startDate = _this$state4.startDate,
          endDate = _this$state4.endDate,
          focusedInput = _this$state4.focusedInput,
          screenSize = _this$state4.screenSize,
          date = _this$state4.date,
          focused = _this$state4.focused;
      var containerProps = getValidElementProps('div', _omit(this.props, ['id']));
      var ntClass = cx(_defineProperty({
        datepicker: true,
        'datepicker-skin': !warning && !error,
        'datepicker-skin--error': error,
        'datepicker-skin--warning': warning,
        'datepicker-skin--withPanel': filters || infoPanelContent
      }, "datepicker--".concat(size), true), className);
      /** These properties are either:
       *   - xps-react custom props not applicable to react-dates components (e.g. disableTyping, type, size, etc.)
       *   - passed into the container (error and label)
       *   - set internally and not allowed to be manipulated by user
       *   - handled in a specific way in <this.AdaptiveDatePicker> below, not just being passed through
       */

      var propsToOmit = ['filters', 'infoPanelContent', 'numberOfMonths', 'type', 'size', 'onFilter', 'onCancel', 'onAccept', 'containerProps', 'className', 'error', 'warning', 'label', 'phrases', 'renderCalendarInfo', 'customInputIcon', 'inputIconPosition', 'customArrowIcon', 'navPrev', 'navNext', 'onFocusChange', 'onDateChange', 'onDatesChange', 'horizontalMargin', 'disableTyping', 'onOutsideClick', 'nextVersion', 'description', 'applyButtonText', 'customFormatList'];
      /* Specific prop omits for either type 'single' or 'range' */

      if (type === 'single') {
        propsToOmit.push('startDate', 'startDateId', 'endDate', 'endDateId', 'focusedInput');
      } else {
        propsToOmit.push('date', 'id', 'focused');
      }

      var dateRangePhrases = _objectSpread(_objectSpread({}, DateRangePickerPhrases), {}, {
        chooseAvailableStartDate: function chooseAvailableStartDate(_ref2) {
          var date = _ref2.date;
          return "Select ".concat(date, " as your start date.");
        },
        chooseAvailableEndDate: function chooseAvailableEndDate(_ref3) {
          var date = _ref3.date;
          return "Select ".concat(date, " as your end date.");
        },
        focusStartDate: 'Start date'
      }, phrases);

      var dateSinglePhrases = _objectSpread(_objectSpread({}, SingleDatePickerPhrases), phrases);

      var renderNextVersion = function renderNextVersion() {
        if (type === 'range') {
          return /*#__PURE__*/React.createElement(DateRangePicker, _extends({}, _this3.props, {
            phrases: dateRangePhrases,
            key: elKey,
            startDate: startDate,
            endDate: endDate,
            focusedInput: focusedInput,
            onFocusChange: _this3.onFocusChange,
            onDatesChange: _this3.onDatesChange,
            renderCalendarInfo: filters.length > 0 || infoPanelContent ? _this3.renderCalendarInfo : function () {}
          }));
        } else {
          return /*#__PURE__*/React.createElement(SingleDatePicker, _extends({}, _this3.props, {
            phrases: dateSinglePhrases,
            displayFormat: displayFormat,
            key: elKey,
            date: date,
            focused: focused,
            onFocusChange: _this3.onFocusChange,
            onDateChange: _this3.onDateChange,
            renderCalendarInfo: filters.length > 0 || infoPanelContent ? _this3.renderCalendarInfo : function () {}
          }));
        }
      };

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AdaptiveListener, {
        onMobileSize: this.onMobileSize,
        onTabletSize: this.onTabletSize,
        onDesktopSize: this.onDesktopSize
      }, nextVersion && screenSize !== 'mobile' ? renderNextVersion() : /*#__PURE__*/React.createElement("div", _extends({
        className: ntClass
      }, containerProps), label !== undefined ? /*#__PURE__*/React.createElement("div", {
        className: "input__label-required__container"
      }, /*#__PURE__*/React.createElement(Label, {
        htmlFor: id,
        text: label,
        className: "input__label",
        warning: warning
      }), required ? /*#__PURE__*/React.createElement("span", {
        className: "input__label-required font-sm"
      }, "Required") : null) : null, /*#__PURE__*/React.createElement(this.AdaptiveDatePicker, _extends({
        key: elKey
      }, type === 'range' && {
        initialVisibleMonth: initialVisibleMonth
      }, {
        phrases: type === 'range' ? dateRangePhrases : dateSinglePhrases,
        customProps:
        /** See description on propsToOmit const above  */
        _omit(this.props, propsToOmit),
        state: this.state
      }, type === 'single' && {
        onDateChange: this.onDateChange
      }, type === 'range' && {
        onDatesChange: this.onDatesChange
      }, {
        onFocusChange: this.onFocusChange,
        numberOfMonths: screenSize === 'mobile' ? 1 : numberOfMonths,
        renderCalendarInfo: filters.length > 0 || infoPanelContent ? this.renderCalendarInfo : function () {}
      })), error ? /*#__PURE__*/React.createElement("div", {
        role: "alert",
        className: "input__info color-text--error",
        id: "".concat(label, "__error")
      }, error) : null, description && !error && /*#__PURE__*/React.createElement("div", {
        className: "input__info"
      }, description))));
    }
  }]);

  return DatePicker;
}(Component);

_defineProperty(DatePicker, "propTypes", {
  /** Additional classes */
  className: PropTypes.string,

  /** Initial date */
  date: PropTypes.oneOfType([PropTypes.object, PropTypes.instanceOf(Moment)]),

  /** Start date for range */
  startDate: PropTypes.oneOfType([PropTypes.object, PropTypes.instanceOf(Moment)]),

  /** End date for range */
  endDate: PropTypes.oneOfType([PropTypes.object, PropTypes.instanceOf(Moment)]),

  /** Component id */
  id: PropTypes.string,

  /** Start date input id */
  startDateId: PropTypes.string,

  /** End date input id */
  endDateId: PropTypes.string,

  /** Function to call on date change */
  onDateChange: PropTypes.func,

  /** Function to call on range dates change */
  onDatesChange: PropTypes.func,

  /** Function to call on focus change */
  onFocusChange: PropTypes.func,

  /** Function to call when filter is triggered */
  onFilter: PropTypes.func,

  /** Function to call when date picker is canceled */
  onCancel: PropTypes.func,

  /** Function to call when date picker is accepted */
  onAccept: PropTypes.func,

  /** Focused input of date range (can be null) */
  focusedInput: PropTypes.oneOf(['START_DATE', 'END_DATE']),

  /** If input is focused */
  focused: PropTypes.bool,

  /** custom info panel content component function */
  infoPanelContent: PropTypes.func,

  /** Array of different filters that can be called from info panel. 'selectedFilterButtonName' is currently not working and hard-coded to 'filterBtn-[index+1]' according to the index within the filter list. This will be fixed on version 2. */
  filters: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    startDate: PropTypes.oneOfType([PropTypes.object, PropTypes.instanceOf(Moment)]),
    endDate: PropTypes.oneOfType([PropTypes.object, PropTypes.instanceOf(Moment)]),
    date: PropTypes.oneOfType([PropTypes.object, PropTypes.instanceOf(Moment)]),
    selectedFilterButtonName: PropTypes.string,
    selected: PropTypes.bool
  })),

  /** Label for preset dates (smart dates) section */
  presetDatesLabel: PropTypes.string,

  /** Info panel size */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /** Type of date picker (single or range) */
  type: PropTypes.oneOf(['single', 'range']),

  /** The number of months to display on the date picker */
  numberOfMonths: PropTypes.number,

  /** Keep calendar panel open until user click apply, used on date range picker with filter */
  keepOpenOnDateSelect: PropTypes.bool,

  /** Display error description below the date picker field */
  error: PropTypes.string,

  /** Display warning description */
  warning: PropTypes.bool,

  /** Display description below the input field */
  description: PropTypes.string,

  /** Display input label */
  label: PropTypes.string,

  /** Display "Required" */
  required: PropTypes.bool,

  /** for default phrases that can be overridden see:
   * https://github.com/airbnb/react-dates/blob/master/src/defaultPhrases.js */
  phrases: PropTypes.object,
  hideKeyboardShortcutsPanel: PropTypes.bool,

  /** Examples: "DD MMM YYYY", "MMM D" */
  displayFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /** The pixel size of the day blocks */
  daySize: PropTypes.number,
  initialVisibleMonth: PropTypes.func,

  /** Placeholder for single datepicker input */
  placeholder: PropTypes.string,

  /** Placeholder for start date input on date range picker */
  startDatePlaceholderText: PropTypes.string,

  /** Placeholder for end date input on date range picker */
  endDatePlaceholderText: PropTypes.string,

  /** This is optional function to override the outside click behavior and replace it with your own. */
  onOutsideClick: PropTypes.func,

  /** Disables typing in the Datepicker's input fields, so only datepicker selections from the opened panel can update the selected date */
  disableTyping: PropTypes.bool,

  /** Alternate Apply Info Panel button text */
  applyButtonText: PropTypes.string,

  /** Set this to true to use the next version of DatePicker with custom date input component. This is still in active development and will be released as part of xps-react version 2.0.0 where this prop will not be needed. */
  nextVersion: PropTypes.bool,

  /** List of allowed date formats on user entry, changed to displayFormat on blur (only available with 'nextVersion' set to true) */
  customFormatList: PropTypes.array
});

_defineProperty(DatePicker, "defaultProps", {
  date: null,
  startDate: null,
  endDate: null,
  focusedInput: null,
  focused: false,
  size: 'small',
  numberOfMonths: 1,
  onDateChange: function onDateChange() {},
  onDatesChange: function onDatesChange() {},
  onFocusChange: function onFocusChange() {},
  onFilter: function onFilter() {},
  onCancel: function onCancel() {},
  onAccept: function onAccept() {},
  required: false,
  filters: [],
  startDateId: 'startDateId',
  endDateId: 'endDateId',
  phrases: {},
  hideKeyboardShortcutsPanel: true,
  displayFormat: 'MM/DD/YYYY',
  daySize: 36,
  keepOpenOnDateSelect: false,
  disableTyping: false,
  applyButtonText: 'Apply',
  nextVersion: false,
  customFormatList: []
});

export { DatePicker as default };
DatePicker.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onDateChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "date",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onDatesChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ startDate, endDate }",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onFocusChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "focus",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onFilter",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "data",
      "type": null
    }],
    "returns": null
  }, {
    "name": "getInitialVisibleMonth",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "checkVisibleMonth",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "prevStartDate",
      "type": null
    }, {
      "name": "newStartDate",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onCancel",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onAccept",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onMobileSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onTabletSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onDesktopSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "calcDaySize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "setInternalDates",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onOutsideClickListener",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "AdaptiveDatePicker",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "ownProps",
      "type": null
    }],
    "returns": null
  }, {
    "name": "updateSize",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "size",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderCalendarInfo",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "DatePicker",
  "props": {
    "date": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "instanceOf",
          "value": "Moment"
        }]
      },
      "required": false,
      "description": "Initial date"
    },
    "startDate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "instanceOf",
          "value": "Moment"
        }]
      },
      "required": false,
      "description": "Start date for range"
    },
    "endDate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "instanceOf",
          "value": "Moment"
        }]
      },
      "required": false,
      "description": "End date for range"
    },
    "focusedInput": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'START_DATE'",
          "computed": false
        }, {
          "value": "'END_DATE'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Focused input of date range (can be null)"
    },
    "focused": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "If input is focused"
    },
    "size": {
      "defaultValue": {
        "value": "'small'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Info panel size"
    },
    "numberOfMonths": {
      "defaultValue": {
        "value": "1",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "The number of months to display on the date picker"
    },
    "onDateChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to call on date change"
    },
    "onDatesChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to call on range dates change"
    },
    "onFocusChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to call on focus change"
    },
    "onFilter": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to call when filter is triggered"
    },
    "onCancel": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to call when date picker is canceled"
    },
    "onAccept": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to call when date picker is accepted"
    },
    "required": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Display \"Required\""
    },
    "filters": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "name": {
              "name": "string",
              "required": false
            },
            "startDate": {
              "name": "union",
              "value": [{
                "name": "object"
              }, {
                "name": "instanceOf",
                "value": "Moment"
              }],
              "required": false
            },
            "endDate": {
              "name": "union",
              "value": [{
                "name": "object"
              }, {
                "name": "instanceOf",
                "value": "Moment"
              }],
              "required": false
            },
            "date": {
              "name": "union",
              "value": [{
                "name": "object"
              }, {
                "name": "instanceOf",
                "value": "Moment"
              }],
              "required": false
            },
            "selectedFilterButtonName": {
              "name": "string",
              "required": false
            },
            "selected": {
              "name": "bool",
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": "Array of different filters that can be called from info panel. 'selectedFilterButtonName' is currently not working and hard-coded to 'filterBtn-[index+1]' according to the index within the filter list. This will be fixed on version 2."
    },
    "startDateId": {
      "defaultValue": {
        "value": "'startDateId'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Start date input id"
    },
    "endDateId": {
      "defaultValue": {
        "value": "'endDateId'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "End date input id"
    },
    "phrases": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "for default phrases that can be overridden see:\nhttps://github.com/airbnb/react-dates/blob/master/src/defaultPhrases.js"
    },
    "hideKeyboardShortcutsPanel": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "displayFormat": {
      "defaultValue": {
        "value": "'MM/DD/YYYY'",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "func"
        }]
      },
      "required": false,
      "description": "Examples: \"DD MMM YYYY\", \"MMM D\""
    },
    "daySize": {
      "defaultValue": {
        "value": "36",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "The pixel size of the day blocks"
    },
    "keepOpenOnDateSelect": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Keep calendar panel open until user click apply, used on date range picker with filter"
    },
    "disableTyping": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Disables typing in the Datepicker's input fields, so only datepicker selections from the opened panel can update the selected date"
    },
    "applyButtonText": {
      "defaultValue": {
        "value": "'Apply'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Alternate Apply Info Panel button text"
    },
    "nextVersion": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set this to true to use the next version of DatePicker with custom date input component. This is still in active development and will be released as part of xps-react version 2.0.0 where this prop will not be needed."
    },
    "customFormatList": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "List of allowed date formats on user entry, changed to displayFormat on blur (only available with 'nextVersion' set to true)"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Additional classes"
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Component id"
    },
    "infoPanelContent": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "custom info panel content component function"
    },
    "presetDatesLabel": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Label for preset dates (smart dates) section"
    },
    "type": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'single'",
          "computed": false
        }, {
          "value": "'range'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Type of date picker (single or range)"
    },
    "error": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Display error description below the date picker field"
    },
    "warning": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Display warning description"
    },
    "description": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Display description below the input field"
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Display input label"
    },
    "initialVisibleMonth": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Placeholder for single datepicker input"
    },
    "startDatePlaceholderText": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Placeholder for start date input on date range picker"
    },
    "endDatePlaceholderText": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Placeholder for end date input on date range picker"
    },
    "onOutsideClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "This is optional function to override the outside click behavior and replace it with your own."
    }
  }
};